import { render, staticRenderFns } from "./shouhou-steps1.vue?vue&type=template&id=06fed438&scoped=true"
import script from "./shouhou-steps1.vue?vue&type=script&lang=js"
export * from "./shouhou-steps1.vue?vue&type=script&lang=js"
import style0 from "./shouhou-steps1.vue?vue&type=style&index=0&id=06fed438&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fed438",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06fed438')) {
      api.createRecord('06fed438', component.options)
    } else {
      api.reload('06fed438', component.options)
    }
    module.hot.accept("./shouhou-steps1.vue?vue&type=template&id=06fed438&scoped=true", function () {
      api.rerender('06fed438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformOrderManagement/components/shouhou-steps1.vue"
export default component.exports